// extracted by mini-css-extract-plugin
module.exports = {"displayLabel":"ActiveClassroomSelect_displayLabel__ilB6W","select":"ActiveClassroomSelect_select__6p6U8"};